import React from "react";
import { Carousel } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

function AfroHall() {
    return(
        
        <div className="container">
            <h1 className="display-1 page-title">Afro Hall</h1>
        
            <h6> Discover African foods, enjoy Afrobeats, Caribbean music in a trendy venue in Miami, Florida</h6>
            <div>
            <Carousel>
            <Carousel.Item>
            <img className="d-block w-100" src="https://unieros.com/wp-content/uploads/2023/07/afrohall_scene.png" alt="Afro hall dance music"/>
                <Carousel.Caption>
                    <h3>Afrobeats, Reggae music meet Caribbean and African food</h3>
                    <p>Mix and mingle with the African diaspora</p>
                </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
                <img
                    className="d-block w-100"
                    src="https://unieros.com/wp-content/uploads/2023/07/food_plate.png"
                    alt="African, Caribbean cuisine"
                />
                <Carousel.Caption>
                    <h3>African and Caribbean cuisine</h3>
                    <p>Taste foods from the African diaspora.</p>
                </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
                <img
                    className="d-block w-100"
                    src="https://unieros.com/wp-content/uploads/2023/07/AfroHouse_food.png"
                    alt="Afro House flyer"
                />
                <Carousel.Caption>
                    
                </Carousel.Caption>
            </Carousel.Item>
        </Carousel>
            
            </div>
            <div className="mt-3">
                <p className="lead">Afro-Hall events are open Friday, Saturday and Sunday from 6:30PM-midnight</p>
                <p>Join us at an upcoming Afro-House event.</p>
                <a href="https://forms.gle/UJjeeTBJoccSAu3k8" className="btn btn-custom-primary cap-link">Get Notified </a>
            </div>

        
        </div>
    )

}
export default AfroHall;